var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParkingLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89D2E8"
    },
    d: "M256,325.818c-12.853,0-23.273,10.42-23.273,23.273v139.636C232.727,501.58,243.147,512,256,512 c12.853,0,23.273-10.42,23.273-23.273V349.091C279.273,336.238,268.853,325.818,256,325.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7AC0DE"
    },
    d: "M256,325.818V512c12.853,0,23.273-10.42,23.273-23.273V349.091 C279.273,336.238,268.853,325.818,256,325.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5192C9"
    },
    d: "M418.909,0H93.091C80.238,0,69.818,10.42,69.818,23.273v325.818c0,12.853,10.42,23.273,23.273,23.273 h325.818c12.853,0,23.273-10.42,23.273-23.273V23.273C442.182,10.42,431.762,0,418.909,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#447BA7"
    },
    d: "M418.909,0H256v372.364h162.909c12.853,0,23.273-10.42,23.273-23.273V23.273 C442.182,10.42,431.762,0,418.909,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5F4FA"
    },
    d: "M279.273,93.091h-46.545c-12.853,0-23.273,10.42-23.273,23.273v46.545v46.545V256 c0,12.853,10.42,23.273,23.273,23.273C245.58,279.273,256,268.853,256,256v-23.273h23.273c38.499,0,69.818-31.319,69.818-69.818 S317.772,93.091,279.273,93.091z M279.273,186.182H256v-23.273v-23.273h23.273c12.833,0,23.273,10.44,23.273,23.273 S292.105,186.182,279.273,186.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0FCFF"
    },
    d: "M279.273,93.091H256v46.545h23.273c12.833,0,23.273,10.44,23.273,23.273s-10.44,23.273-23.273,23.273 H256v46.545h23.273c38.499,0,69.818-31.319,69.818-69.818S317.772,93.091,279.273,93.091z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingLogo);
export default __webpack_public_path__ + "static/media/parkingLogo.d963d7d37b7a8dc10d28449160a6051f.svg";
export { ForwardRef as ReactComponent };